import { jsx as _jsx } from "react/jsx-runtime";
import { SkeletonTheme } from 'react-loading-skeleton';
export const SkeletonThemeDefault = ({ width, heigth, children, borderRadius = 16, isDark, baseColor, highlightColor, }) => {
    baseColor = baseColor || (isDark ? '#f0f0f0' : '#f6f6f6');
    highlightColor = highlightColor || (isDark ? '#eaeaea' : '#eaeaea');
    return (_jsx(SkeletonTheme, Object.assign({ width: width, height: heigth, borderRadius: borderRadius, baseColor: baseColor, highlightColor: highlightColor, duration: 2, inline: true }, { children: children })));
};
